import { createPortal } from 'react-dom';
import { useState, useEffect } from 'react';
import { useDebounceValue } from 'usehooks-ts';

import { Config } from 'config';
import { useAlert } from 'hooks';
import { Suspense } from 'components';
import { getErrorMessage } from 'utils/error';
import { useAppDispatch, useAppSelector } from 'store';
import { setAuthError, selectAuthError } from 'store/slices/auth';

import Router from './router';
import { useSetupUserLogs } from './use-setup-user-logs';

const App = () => {
  const [error, setError] = useState<string | undefined>(undefined);

  const { showErrorAlert } = useAlert();
  const dispatch = useAppDispatch();

  const authError = useAppSelector(selectAuthError);

  const [errorDebounce] = useDebounceValue(error, 1000);

  useSetupUserLogs();

  useEffect(() => {
    if (authError) {
      setError(getErrorMessage(authError));
      dispatch(setAuthError(undefined));
    }
  }, [authError]);

  useEffect(() => {
    if (errorDebounce) {
      showErrorAlert(errorDebounce);
      setError(undefined);
    }
  }, [errorDebounce]);

  const captchaElement = Config.waf.enabled
    ? createPortal(
        <div
          id="modalOverlay"
          className="fixed inset-0 z-[9999] flex hidden items-center justify-center bg-black/60"
        >
          <div
            id="captchaForm"
            className="fixed top-1/2 left-1/2 -translate-x-1/2 -translate-y-1/2 bg-white p-4"
          />
        </div>,
        document.body
      )
    : undefined;

  return (
    <Suspense>
      <Router />

      {captchaElement}
    </Suspense>
  );
};

export default App;
